import { render, staticRenderFns } from "./ui-button.vue?vue&type=template&id=c8c74272&scoped=true"
import script from "./ui-button.vue?vue&type=script&lang=js"
export * from "./ui-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c74272",
  null
  
)

export default component.exports